import * as Yup from "yup";
import { supportedEmailCharacters } from "../utils/emailSupportedCharacters";

export const sponsorMasterUserValidationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").test(supportedEmailCharacters).required("Email is required"),
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  // The master attaches to an existing sponsor organization (created via Add New Sponsor,
  // which owns the HyperComply org id + subscription). Selecting it is required so we never
  // mint a brand-new, bare org for the master.
  sponsor_id: Yup.string().required("Please select a sponsor organization"),
  phone_number: Yup.string()
    .matches(/^1-\d{3}-\d{3}-\d{4}$/, "Phone number must be in the format 1-234-567-8900")
    .required("Phone number is required"),
  office_phone_number: Yup.string()
    .matches(/^1-\d{3}-\d{3}-\d{4}$/, "Office phone number must be in the format 1-234-567-8900")
    .required("Office phone number is required"),
  contact_preference: Yup.string().required("Contact preference is required"),
});

export const sponsorMasterUserFields = [
  {
    name: "email",
    label: "Email",
    type: "email",
    placeholder: "Enter email",
  },
  {
    // Organization picker. Options are injected at runtime from the sponsor list so the
    // master is attached to an existing org instead of a freshly generated id.
    name: "sponsor_id",
    label: "Sponsor Organization",
    type: "select",
    options: [],
    placeholder: "Select organization",
  },
  {
    name: "first_name",
    label: "First Name",
    type: "text",
    placeholder: "Enter first name",
  },
  {
    name: "last_name",
    label: "Last Name",
    type: "text",
    placeholder: "Enter last name",
  },
  {
    name: "phone_number",
    label: "Phone Number",
    type: "tel",
    placeholder: "Enter phone number",
  },
  {
    name: "office_phone_number",
    label: "Office Phone Number",
    type: "tel",
    placeholder: "Enter office phone number",
  },
  {
    name: "contact_preference",
    label: "Contact Preference",
    type: "select",
    options: [
      { value: "Mobile_Phone", label: "Mobile Phone" },
      { value: "Office_Phone", label: "Office Phone" },
    ],
    className:
      "bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-500",
  },
];
